import { eshopURL, eshopSuccessURL, eshopFailureURL } from 'config/app.config';
import React, { useEffect, useRef } from 'react';

const PaymentTab = ({
	nextFn,
	setOrderId,
	setOrderIsSuccessful,
}: {
	nextFn: () => void;
	setOrderId: React.Dispatch<React.SetStateAction<string>>;
	setOrderIsSuccessful: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
	const iframeRef = useRef<HTMLIFrameElement | null>(null);
	const intervalRef = useRef<number | null>(null);

	useEffect(() => {
		const eshopMessageHandler = (event: MessageEvent) => {
			if (eshopURL.includes(event.origin)) {
				if (event.data.url && event.data.url.includes(eshopSuccessURL)) {
					//https://testshop.omantel.om/payment/success?orderId=342902669775&giftcards=false&digitalproducts=false
					const urlSearchParams = new URLSearchParams(event.data.url);
					setOrderId(Array.from(urlSearchParams.entries())[0][1]);
					setOrderIsSuccessful(true);
					nextFn();
				} else if (event.data.url && event.data.url.includes(eshopFailureURL)) {
					setOrderIsSuccessful(false);
					nextFn();
				}
			}
		};

		window.addEventListener('message', eshopMessageHandler);
		if (intervalRef.current) {
			window.clearInterval(intervalRef.current);
		}
		intervalRef.current = window.setInterval(() => {
			if (iframeRef.current && iframeRef.current.contentWindow) {
				iframeRef.current.contentWindow.postMessage('url', eshopURL);
			}
		}, 1000);

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
			window.removeEventListener('message', eshopMessageHandler);
		};
	}, [nextFn, setOrderId, setOrderIsSuccessful]);

	return <iframe id="inlineFrame" ref={iframeRef} title="eshop" width="100%" height="1200px" src={eshopURL}></iframe>;
};

export default PaymentTab;
